/**
 * API Configuration
 *
 * Central location for all API endpoints and external URLs
 */

// API Endpoints
export const API_ENDPOINTS = {
  templatesData: "/api/templates-data",
} as const;

// Domain Configuration
export const CNAME_TARGET = "cms.ishealth.app";

// External URLs
export const EXTERNAL_URLS = {
  googleFonts: {
    preconnect: "https://fonts.googleapis.com",
    gstatic: "https://fonts.gstatic.com",
  },
} as const;

// Font weights to load
export const FONT_WEIGHTS = "300;400;500;600;700";

/**
 * Generate Google Fonts URL for a given font family
 * @param fontFamily - The font family name (e.g., "Inter", "Sarabun")
 * @returns The complete Google Fonts CSS URL
 */
export function getGoogleFontsUrl(fontFamily: string): string {
  const fontNameForUrl = fontFamily.replace(/ /g, "+");
  return `https://fonts.googleapis.com/css2?family=${fontNameForUrl}:wght@${FONT_WEIGHTS}&display=swap`;
}

/**
 * Generate Google Fonts preconnect links HTML
 * @returns HTML string with preconnect links
 */
export function getGoogleFontsPreconnectHtml(): string {
  return `<link rel="preconnect" href="${EXTERNAL_URLS.googleFonts.preconnect}">
  <link rel="preconnect" href="${EXTERNAL_URLS.googleFonts.gstatic}" crossorigin>`;
}

/**
 * Generate complete Google Fonts HTML links
 * @param fontFamily - The font family name
 * @returns HTML string with preconnect and stylesheet links
 */
export function getGoogleFontsHtml(fontFamily: string): string {
  return `${getGoogleFontsPreconnectHtml()}
  <link href="${getGoogleFontsUrl(fontFamily)}" rel="stylesheet">`;
}
